import { ReactNode } from 'react';

export type ModalProps = {
  isShow: boolean;
  children: ReactNode;
  isBackdrop?: boolean;
  onBackdropDismiss?: (closeModal: () => void) => void;
  className?: string;
  containerClassName?: string;
};

export enum ModalType {
  Auth = 'auth',
  BirthDate = 'birth-date',
  DeliveryAddress = 'delivery-address',
  DeliveryAddressList = 'delivery-address-list',
  DeliveryInfo = 'delivery-info',
  ChangeEmail = 'change-email',
  ChangeName = 'change-name',
  Comment = 'comment',
  ProductDetails = 'product-details',
  ChangeNotifications = 'change-notifications',
  Promocode = 'promocode',
  AddCard = 'add-card',
  DeleteAccount = 'delete-account',
  Logout = 'logout',
  DeleteAddress = 'delete-address',
  DeleteCard = 'delete-card',
  SelectDate = 'select-date',
  SelectDateCD = 'select-date-cd',
  Feedback = 'feedback',
  FeedbackSuccess = 'feedback-success',
  AgeRestriction = 'age-restriction',
  RateApp = 'rate-app',
  Recommendations = 'recommendations',
  CheckoutReciever = 'reciever-data',
  CheckoutAddRecieverData = 'add-reciever-data',
  Check3Ds = 'check-3ds',
  ReferralProgram = 'referral-program',
  SelectSKU = 'select-sku',
  Subscription = 'subscription',
  SubscriptionOff = 'subscription-off',
  EditAddressLocation = 'edit-address-location',
  EditAddressDetails = 'edit-address-details',
  OutOfZone = 'out-of-zone',
  DokobitVerification = 'dokobit-verification',
  TransactionDetails = 'transaction-details',
}
